import Text from '@deprecated-ui/common/Text';
import If from 'global/ErrorHandlers/If';
import { iModal } from '../types';
import Company from './Company';
import { ContentWrapper, HeaderWrapper, Modal, ModalContent } from './styled';

interface iDetailModal extends iModal {
  title?: string;
  symbol?: string;
  children?: JSX.Element | JSX.Element[];
  prefix?: JSX.Element | JSX.Element[];
  suffix?: JSX.Element | JSX.Element[];
  showPrice?: boolean;
  isBonds?: boolean;
  isRedemption?: boolean;
  bondsName?: string;
  onCompanyClick?(): void;
  showBondPrice?: boolean;
}

export const DetailModal = ({
  visible,
  onCancel,
  title,
  symbol,
  children,
  prefix,
  suffix,
  showPrice = true,
  isBonds = false,
  isRedemption = false,
  bondsName = '',
  onCompanyClick,
  showBondPrice = false,
}: iDetailModal) => {
  const onClose = () => {
    onCancel();
  };

  const isCompanyInfoVisible = () => {
    if (title === 'WITHDRAW') return false;
    return !!symbol;
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      centered
      width={520}
      data-cy="trade-detail-modal-container"
      zIndex={1000}
    >
      <ModalContent direction="column">
        <HeaderWrapper>
          <Text
            align="center"
            family="bold"
            size="18px"
            data-cy="trade-detail-modal-title"
          >
            {title}
          </Text>
        </HeaderWrapper>
        <ContentWrapper>
          {prefix}
          <If condition={isCompanyInfoVisible()}>
            <Company
              symbol={symbol}
              showPrice={showPrice}
              isBonds={isBonds}
              isRedemption={isRedemption}
              bondsName={bondsName}
              onClick={onCompanyClick}
              showBondPrice={showBondPrice}
            />
          </If>
          {children}
        </ContentWrapper>

        {suffix}
      </ModalContent>
    </Modal>
  );
};

export default DetailModal;
